import { z } from "zod";

export const TASK_STATUS_VALUES = [
  "queued",
  "running",
  "succeeded",
  "failed",
  "skipped",
  "canceled",
  "cancelled",
] as const;

export const taskStatusSchema = z.enum(TASK_STATUS_VALUES);
export type TaskStatus = z.infer<typeof taskStatusSchema>;

export const TASK_TIMING_EVENT_KIND_VALUES = [
  "phase",
  "model_stage",
  "tool",
  "step",
  "run",
] as const;

export const taskTimingEventKindSchema = z.enum(TASK_TIMING_EVENT_KIND_VALUES);
export type TaskTimingEventKind = z.infer<typeof taskTimingEventKindSchema>;
